<script setup lang="ts">
import { useAlertMessage } from '@/modules/miiaFw/composables/useAlertMessage'
/**
 * @module components/miiafw/util/MiiaFwAlertMessage
 * @description アラートメッセージを保持するComponent。
 * @vue-data {Boolean} [hasError = false] アラートメッセージの有無
 * @vue-data {String} [message = ''] アラートメッセージ
 */
const {
  // data
  hasError,
  message,
  // methods
  addAlertMessage,
  deleteAlertMessage
} = useAlertMessage()

defineExpose({
  hasError,
  message,
  addAlertMessage,
  deleteAlertMessage
})
</script>

<template>
  <div v-if="hasError" class="alert alert-danger" style="text-align: left">
    <button type="button" class="close" @click="deleteAlertMessage">×</button>
    <!-- <button type="button" class="close" data-dismiss="alert" @click="deleteAlertMessage">×</button> -->
    <strong style="white-space: pre-wrap; word-wrap: break-word">{{ message }}</strong>
  </div>
</template>
